import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Paper, Typography, Box, CircularProgress, Alert } from '@mui/material';
import { auth } from '../services/firebase';
import { applyActionCode } from 'firebase/auth';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        // 從 URL 取得 oobCode
        const oobCode = searchParams.get('oobCode');
        if (!oobCode) {
          throw new Error('無效的驗證連結');
        }

        // 使用 Firebase 的 applyActionCode 處理驗證
        await applyActionCode(auth, oobCode);
        
        // 驗證成功，3秒後跳轉到首頁
        setTimeout(() => {
          navigate('/');
        }, 3000);
      } catch (error: any) {
        console.error('Email 驗證失敗:', error);
        setError(error.message || '驗證失敗，請重試');
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8 }}>
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
          {loading ? (
            <>
              <CircularProgress />
              <Typography variant="h6" sx={{ mt: 2 }}>
                正在驗證您的 Email...
              </Typography>
            </>
          ) : error ? (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          ) : (
            <Alert severity="success" sx={{ mt: 2 }}>
              Email 驗證成功！3秒後將自動跳轉到首頁。
            </Alert>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default VerifyEmail; 